
import Context from "../../../context/Context";
import FieldNames from "../../../../src/aiim/datasets/FieldNames";
import * as aiimUtil from "../../../../src/aiim/util/aiimUtil";

export function getAreaName(areaId, url){
    const promise = new Promise((resolve, reject)=>{
        const lib = Context.instance.lib;
        if(!url) resolve(null);
        const serviceJson = aiimUtil.readServiceJson(url);
        let tableId, isAreaTable = false;
        
        serviceJson
        .then(result=>{
            const tables = result.data.tables;
            for(let i=0;i< tables.length;i++){
                if(tables[i].name.toUpperCase() === "AREAS"){
                    tableId = tables[i].id;
                    isAreaTable = true;
                    break;
                }
            }
            if(!isAreaTable) resolve(null);
        })
        .then(()=> {
            const finalUrl = url + "/" + tableId;
            const queryTask = new lib.esri.QueryTask({url: finalUrl});
            const query = new lib.esri.Query();
            const field = FieldNames.AREA_ID;
            query.outFields = ["*"];
            query.where = field + " = '" + areaId + "'";
            return queryTask.execute(query).then(result => {
                if(result.features.length > 0){
                    const attributes = result.features[0].attributes;
                    const areaName = aiimUtil.getAttributeValue(attributes, FieldNames.AREA_NAME);
                    resolve(areaName);
                }else{
                    resolve(null);
                }
            });
        })
        .catch((error)=>{
            console.log("Error", error);
            reject(error);
        })
    })
    return promise;
}